export default __webpack_public_path__ + "static/media/Chimi.7cc07631.jpg";